<div class="chat-menubar flex mt-1 items-center justify-end">
  <p-menubar
    [model]="menuItems"
    class=""
  ></p-menubar>
  <p-button
    ariaLabel="Thumbs up"
    [text]="true"
    [rounded]="true"
    (onClick)="openFeedback('positive-experience')"
    (mouseenter)="hovered = 'up'"
    (mouseleave)="hovered = null"
    styleClass="thumb-button text-blue-500"
  >
      <span
        [ngClass]="hovered === 'up' ? 'pi pi-thumbs-up-fill' : 'pi pi-thumbs-up'"
      ></span>
  </p-button>
  <p-button
    ariaLabel="Thumbs down"
    [text]="true"
    [rounded]="true"
    (onClick)="openFeedback('negative-experience')"
    (mouseenter)="hovered = 'down'"
    (mouseleave)="hovered = null"
    styleClass="thumb-button text-blue-500"
  >
      <span
        [ngClass]="hovered === 'down' ? 'pi pi-thumbs-down-fill' : 'pi pi-thumbs-down'"
      ></span>
  </p-button>
</div>

<lib-feedback-dialog
  *ngIf="showFeedbackDialog && feedbackProps"
  [feedbackProps]="feedbackProps"
  (closeDialog)="closeFeedback()"
  [visible]="true"
  (canceled)="onFeedbackCanceled()"
/>
